import {Icon} from '@wandb/components';
import React from 'react';

export const AgentIcon: React.FC = () => (
  <Icon icon="robot-service-member" size="xs" />
);

export const UserIcon: React.FC = () => (
  <Icon icon="user-profile-personal" size="xs" />
);

export const ChatIcon: React.FC = () => (
  <Icon icon="forum-chat-bubble" size="sm" />
);

export const ClockIcon: React.FC = () => <Icon icon="recent-clock" size="sm" />;

export const ChevronIcon: React.FC<{expanded: boolean}> = ({expanded}) => (
  <span
    className={`inline-flex shrink-0 transition-transform duration-150 ${expanded ? 'rotate-90' : 'rotate-0'}`}>
    <Icon icon="chevron-next" size="xs" />
  </span>
);

export const CheckIcon: React.FC = () => <Icon icon="checkmark" size="xs" />;

export const ResizeGripIcon: React.FC = () => (
  <Icon icon="drag-grip" size="xs" />
);
